import jQuery from "jquery";

const $ = jQuery;

/*

$
encodeURIComponent
crossDomainHosts

*/
const crossSiteTracking = (function($) {  // eslint-disable-line
  const me = {};

  const getNewUrl = function(currentUrl, cookieValue) {

    let toAdd = '';
    const encodedCookieValue = encodeURIComponent(cookieValue);

    if (currentUrl.indexOf('?') > 0) {

      toAdd += '&';

    } else {

      toAdd += '?';

    }

    return currentUrl + toAdd + 's_vi=' + encodedCookieValue;

  };

  const getCrossDomainCookie = function() {

    const cookies = document.cookie.split(';');

    for (let i = 0; i < cookies.length; i++) {

      const cookie = cookies[i].split('=');

      if (cookie[0].trim() === 's_vi') {

        return cookie[1];

      }

    }

    return '';

  };

  const trackThisDomain = function(href) {

    /* eslint-disable */
        const validHosts = crossDomainHosts || [];
        /* eslint-enable */

    for (let i = 0; i < validHosts.length; i++) {

      const host = validHosts[i];

      if (href.length >= host.length) {

        if (href.substring(0, host.length) === host.substring(0, host.length)) {

          return true;

        }

      }

    }

    return false;

  };

  const addCookieValueToLinks = function() {

    const cookieValue = getCrossDomainCookie();

    if (cookieValue.length > 0) {

      const { links } = document;
      for (let i = 0; i < links.length; i++) {

        const c = links[i].href;

        if (trackThisDomain(c)) {

          links[i].href = getNewUrl(c, cookieValue);

        }

      }

    }

  };

  me.init = function() {

    addCookieValueToLinks();

  };

  return me;

})(jQuery); // eslint-disable-line

export default crossSiteTracking;
